// composables/useNavigation.ts
import { useState } from '#app';
import type { NavigationItem, NavigationState } from '~/components/Aggregates/Navigation/types';

export function useNavigation() {
  const state = useState<NavigationState>('navigation', () => ({
    activeSubNavigation: null,
    activeSubNavigation2: null,
    activeSubNavigation3: null
  }));

  const clearActiveSubNavigation = () => {
    state.value = {
      activeSubNavigation: null,
      activeSubNavigation2: null,
      activeSubNavigation3: null
    };
  };

  watch(
    () => state.value.activeSubNavigation,
    () => {
      state.value = {
        ...state.value,
        activeSubNavigation2: null,
        activeSubNavigation3: null
      };
    }
  );

  watch(
    () => state.value.activeSubNavigation2,
    () => {
      state.value = {
        ...state.value,
        activeSubNavigation3: null
      };
    }
  );

  const selectNavigationLink = (e: Event, item: NavigationItem, stateKey?: keyof NavigationState) => {
    if (!stateKey) return;

    e.preventDefault();
    state.value = {
      ...state.value,
      [stateKey]: item
    };
  };

  return {
    state,
    clearActiveSubNavigation,
    selectNavigationLink
  };
}
